import useRuntimeConfig from '@/composables/useRuntimeConfig';
import { InsuranceDocumentsResponse } from '@/models/api/InsuranceResponse';
import { CharityContent, WPContent } from '@/models/Content';
import { ModeOfTravelEnum } from '@/models/enums';
import axios from 'axios';

const contentService = {
    getContent(page: string, modeOfTravel: ModeOfTravelEnum, route: string): Promise<WPContent[]> {
        const { getRuntimeConfig } = useRuntimeConfig();

        return new Promise((resolve, reject) => {
            getRuntimeConfig().then(x => {
                axios.get(`${x.cmsBaseUrl}content/content?page=${page}&modeOfTravel=${modeOfTravel}&route=${route}`)
                    .then(resp => resolve(resp.data?.content as WPContent[] ?? []))
                    .catch((err) => reject(err))
            });
        });
    },
    getCharityContent(): Promise<CharityContent[]> {
        const { getRuntimeConfig } = useRuntimeConfig();

        return new Promise((resolve, reject) => {
            getRuntimeConfig().then(x => {
                axios.get(`${x.cmsBaseUrl}content/charity`)
                    .then(resp => resolve(resp.data as CharityContent[]))
                    .catch((err) => reject(err))
            });
        });
    },
    getInsuranceDocuments(): Promise<InsuranceDocumentsResponse[]> {
        const { getRuntimeConfig } = useRuntimeConfig();

        return new Promise((resolve, reject) => {
            getRuntimeConfig().then(x => {
                axios.get(`${x.cmsBaseUrl}content/insurance/documents`)
                    .then(resp => resolve(resp.data as InsuranceDocumentsResponse[]))
                    .catch((err) => reject(err))
            });
        });
    }
}

export default contentService;